/**
 * AWS Cognito Authentication Configuration
 */

import { Amplify } from 'aws-amplify';

// Cognito configuration from environment variables
const cognitoConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  region: import.meta.env.VITE_COGNITO_REGION || 'ap-southeast-2',
  domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
};

// Get the redirect URL based on environment
const getRedirectUrl = () => {
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    return `${origin}/auth/callback`;
  }
  return 'https://hipponics.com/auth/callback';
};

const getSignOutUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'https://hipponics.com';
};

// Configure Amplify for Cognito with OAuth (Google sign-in)
export function configureAuth() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cognitoConfig.userPoolId,
        userPoolClientId: cognitoConfig.userPoolClientId,
        signUpVerificationMethod: 'code',
        loginWith: {
          email: true,
          oauth: {
            domain: `${cognitoConfig.domain}.auth.${cognitoConfig.region}.amazoncognito.com`,
            scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [getRedirectUrl()],
            redirectSignOut: [getSignOutUrl()],
            responseType: 'code',
            providers: ['Google'],
          },
        },
      },
    },
  });
}

export { cognitoConfig };
